// TikTok-аккаунты в общей модели Account: один кэшированный источник вместо
// семи независимых listTikTokAccounts() по экранам. Instagram-аккаунты живут
// в accountStore (грузятся из KV), TikTok приходит из Display API — общий у них
// только тип Account с полем platform.
import { useEffect, useState } from 'react';

import { getTikTokAccounts, type TikTokAccount } from '../../../shared/api/tiktok.api';
import type { Account } from './types';

// Префикс id: TikTok- и Instagram-аккаунты лежат в одном списке (селекторы,
// таблицы), по префиксу код ветвит загрузку статистики и отчёты.
export const TIKTOK_ID_PREFIX = 'tt:';

export function tiktokAccountId(openId: string): string {
  return `${TIKTOK_ID_PREFIX}${openId}`;
}

export function isTikTokAccountId(id: string): boolean {
  return id.startsWith(TIKTOK_ID_PREFIX);
}

/** `tt:<openId>` → `<openId>`; не-TikTok id возвращается как есть. */
export function openIdFromAccountId(id: string): string {
  return isTikTokAccountId(id) ? id.slice(TIKTOK_ID_PREFIX.length) : id;
}

export function tiktokToAccount(tt: TikTokAccount): Account {
  return {
    id: tiktokAccountId(tt.openId),
    platform: 'tiktok',
    openId: tt.openId,
    name: tt.displayName || tt.username || tt.openId,
    username: tt.username,
    // Display API отдаёт только аккаунты с живым токеном; даты подключения нет.
    isActive: true,
    createdAt: new Date(0),
    updatedAt: new Date(0),
    tags: [],
  };
}

/** Подключённые TikTok-аккаунты как Account[]. Ошибка → пустой список. */
export function useTikTokAccounts(): { accounts: Account[]; isLoading: boolean } {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTikTokAccounts()
      .then((list) => {
        if (!cancelled) setAccounts(list.map(tiktokToAccount));
      })
      .catch(() => {
        // TikTok не настроен / бэк недоступен — экран остаётся Instagram-only.
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { accounts, isLoading };
}
